<template>
    <router-link :to="{ name : b.link }" active-class="breadcrumb-item-active" class="breadcrumb-item" >
        <!--<i v-if="index == 0" class="icon-home2 mr-2"></i> --><span>{{b.name}}</span>
    </router-link>
</template>

<script>

export default {
    props: {
        breadcrumb: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    components : {
    },
    computed : {
        b() { return this.breadcrumb}
    },

}

</script>